import React from 'react';

import moreMenuStyles from './AlmeMoreMenu.styles';

import { withStyles, WithStyles } from '@material-ui/core/styles';

import { AlmeMoreMenuConfig } from './AlmeMoreMenuConfig';
import AlmeConfigFormControl, { BoolPropTypes, ConfigControlGroups } from '../AlmeConfigFormControl/AlmeConfigFormControl';

interface AlmeMoreMenuConfigToolProps extends WithStyles<typeof moreMenuStyles> {
    almeConfig: AlmeMoreMenuConfig;
    onConfigChange: (almeConfig: AlmeMoreMenuConfig) => void;
}

const AlmeAlmeMoreMenuConfigTool: React.FC<AlmeMoreMenuConfigToolProps> = (props: AlmeMoreMenuConfigToolProps) => {
    const isEmailTranscriptEnabled = props.almeConfig.moreMenu.isEmailTranscriptEnabled.toString() as BoolPropTypes;

    const setIsEmailTranscriptEnabled = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value;
        const almeConfig = props.almeConfig;
        almeConfig.moreMenu.isEmailTranscriptEnabled = newValue === 'true';
        props.onConfigChange(almeConfig);
    };

    const configControls: ConfigControlGroups[] = [
        {
            name: 'More Menu',
            controlGroups: [
                {
                    label: 'Is Email Transcript Enabled',
                    name: 'isEmailTranscriptEnabled',
                    value: isEmailTranscriptEnabled,
                    changeHandler: setIsEmailTranscriptEnabled,
                    radioButtons: ['true', 'false'],
                },
            ],
        },
    ];

    return (
        <AlmeConfigFormControl title='Alme More Menu Config' configControls={configControls} />
    );
};

export default withStyles(moreMenuStyles)(AlmeAlmeMoreMenuConfigTool);
